module.exports = __webpack_public_path__ + "img/resize-tables-icon.de3a71fe.svg";